import React, { Fragment } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';

import { STUDENT_NOTES_REPORT_FORM_NAME } from 'Common/FormEnum';
import { NotesReportFieldEnum } from 'Common/FieldEnum';
import { ReportFormatButtonGroup } from 'Components/forms/ReportFormatButtonGroup';
import { SiteComponent } from '../../common/SiteComponent';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { TitledCard } from 'Components/';
import { Toggle } from 'Common/SemanticWrapper';

const sortOptions = [
  { value: 0, label: 'Last, First Name' },
  { value: 1, label: 'Serving #' },
  { value: 2, label: 'Student #' },
];

const NotesReportForm = () => {
  return (
    <Fragment>
      <Form name={STUDENT_NOTES_REPORT_FORM_NAME}>
        <TitledCard title={'Report Parameters'}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <ReportFormatButtonGroup
                  label={'Export Type'}
                  formName={STUDENT_NOTES_REPORT_FORM_NAME}
                  fieldName={NotesReportFieldEnum.ReportFormat}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width="6">
                <SiteComponent
                  name={NotesReportFieldEnum.Site}
                  isForm={true}
                  isPrimary={true}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width="9">
                <ReduxFormButtonGroup
                  label={'Sort By'}
                  formName={STUDENT_NOTES_REPORT_FORM_NAME}
                  options={sortOptions}
                  fieldName={NotesReportFieldEnum.SortBy}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingTop: '25px' }}>
              <Grid.Column width="6">
                <Field
                  name={NotesReportFieldEnum.SystemGeneratedOnly}
                  component={Toggle}
                  label={'System Generated Notes Only'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    </Fragment>
  );
};

const validate = (values) => {
  let errors = {};
  if (!values[NotesReportFieldEnum.Site]) {
    errors[NotesReportFieldEnum.Site] = 'A site must be selected.';
  }
  return errors;
};

export default reduxForm({
  form: STUDENT_NOTES_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
})(withRouter(NotesReportForm));



// WEBPACK FOOTER //
// ./src/pages/notesreport/NotesReportForm.js